var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 208,
    viewBox: "0 0 215 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3021_978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 215,
    height: 208
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 208,
    rx: 31,
    fill: "#4B4B4B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3021_978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 216,
    height: 209,
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.983 75.7144C158.978 75.5548 158.955 75.3966 158.92 75.2383C158.907 75.1834 158.899 75.1297 158.883 75.0774C158.826 74.8812 158.751 74.6864 158.644 74.5007C158.537 74.3149 158.404 74.1528 158.263 74.0037C158.226 73.9644 158.184 73.9304 158.145 73.8951C158.023 73.7826 157.895 73.6832 157.758 73.5969C157.73 73.5786 157.708 73.5537 157.678 73.5367L108.817 45.3531C108.001 44.8823 106.995 44.8823 106.179 45.3531L57.3183 73.5354C57.2895 73.5524 57.2673 73.5786 57.2385 73.5969C57.1023 73.6819 56.9753 73.7813 56.8549 73.8912C56.8143 73.9291 56.7711 73.9644 56.7318 74.005C56.5917 74.1528 56.4621 74.3123 56.3548 74.4954C56.3535 74.498 56.3522 74.502 56.3495 74.5046C56.2435 74.689 56.1702 74.8799 56.1126 75.0748C56.0969 75.1284 56.0877 75.1834 56.0759 75.237C56.0406 75.3966 56.0196 75.5548 56.0131 75.7144C56.0118 75.7484 56 75.7811 56 75.8164V132.182C56 133.124 56.5027 133.994 57.3183 134.465L106.18 162.647C106.212 162.665 106.248 162.672 106.281 162.687C106.42 162.762 106.565 162.821 106.718 162.868C106.773 162.886 106.826 162.906 106.882 162.919C107.081 162.967 107.287 163 107.5 163C107.713 163 107.919 162.969 108.118 162.919C108.173 162.906 108.227 162.886 108.282 162.868C108.435 162.821 108.58 162.762 108.719 162.687C108.752 162.67 108.787 162.664 108.82 162.647L157.682 134.465C158.497 133.994 159 133.124 159 132.182V75.8177C158.997 75.7824 158.984 75.7497 158.983 75.7144ZM107.499 50.6775L151.085 75.8177L107.499 100.957L63.9113 75.8177L107.499 50.6775ZM110.135 155.801V105.521L153.721 80.3822V130.663L110.135 155.801Z",
    fill: "#777777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.da549c6584e835c52043a4b721f41946.svg";
export { ForwardRef as ReactComponent };